<p>notification-template-sms-edit works!</p>
